import { useFlags } from 'launchdarkly-react-client-sdk';
import { useEffect } from 'react';

import { Routes } from './routes/Routes';
import { Routes as RoutesRevamp } from 'components/app/routes/RoutesRevamp';
import { Maintenance } from 'components/app/routes/Maintenance';
import { Feature } from 'components/common/feature/Feature';
import { useAnalytics } from 'analytics/useAnalytics';
import { ScrollToTop } from '../common/scroll-top/ScrollToTop';
import { useChatEvents } from 'analytics/useChatEvents';
import { useAuthentication } from 'hooks/useAuthentication';
import { useOnExit } from 'hooks/useOnExit';
import { DevMenu } from 'components/app/DevMenu';
import { useRevampJourney } from 'hooks/useRevampJourney';
import { setFlags } from 'state/settings/settings-slice';
import { useAppDispatch } from 'hooks/useAppDispatch';

const { VITE_BRANCH } = import.meta.env;

export const testId = 'appTestId';

export const App = () => {
  const dispatch = useAppDispatch();
  const flags = useFlags();
  const { showApplicationMaintenanceMode } = flags;
  const { isRevampJourney } = useRevampJourney();
  const stringFlags = JSON.stringify(flags);
  const jsonFlags = JSON.parse(stringFlags);
  useChatEvents();
  useAuthentication();
  useAnalytics();
  useOnExit();

  useEffect(() => {
    dispatch(setFlags(jsonFlags));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stringFlags]);

  return (
    <div data-testid={testId}>
      <DevMenu viteBranch={VITE_BRANCH} />
      <ScrollToTop />
      <Feature
        feature={showApplicationMaintenanceMode}
        inactiveComponent={isRevampJourney ? <RoutesRevamp /> : <Routes />}
      >
        <Maintenance />
      </Feature>
    </div>
  );
};
